<template>
  <div class="result-race">
    <div class="title-wr p-n">
      <div class="title text-ellipsies">{{ event.meetingName }} {{ event.eventTime }}</div>
      <div class="sport-icon" v-html="sport.svg"></div>
    </div>
    <div class="p-n">
      <div 
        v-for="(res, index) in event.results" 
        :key="index"
        class="result-line"
      >
        <div class="result-main">
          <race-number 
            v-if="['Greyhounds', 'Virtual Greyhounds'].includes(sport.title)"
            class="ms-2" 
            :race-number="parseInt(res?.selectionNumber)"
            selectionNumber/>
          <race-number 
            v-else
            class="race-number-comp"
            color="#000000" 
            :race-number="parseInt(res.resultPlace)" 
            result/>
          <div v-if="res?.silkLogoUrl" class="racer-image-wr ms-2">
            <img :src="res.silkLogoUrl" alt="">
          </div>

          <div class="ms-2 text-ellipsies">{{ res.selectionName }}</div>
          <div></div>
         
        </div>
        <div class="result-odd">{{ glb.formatPrice(res.odds) }}</div>

      </div>
    </div>
  </div>

</template>

<script>

import RaceNumber from "@/components/UI/RaceNumber";

export default {
  name: "RaceResultsSliderItem",
  components: { 
    RaceNumber
  },

  props: {
    event: {
      type: Object,
    }
  },
  data: ()=>{
    return {
    }
  },
  computed: {
    sport() {
      return this.API.SPORTS.find(sport => sport.code.split(',').includes(this.event.sportcode))
    }
  },
  methods:{
    formatDate(eventDate){
      let rawDate = new Date(eventDate.split('-').reverse().join('-'))
      let today = new Date()
      if (rawDate.getDate()===today.getDate() && rawDate.getFullYear()===today.getFullYear() && rawDate.getMonth()===today.getMonth()){
        return 'Today'
      } else {
        return eventDate
      }
    },
  },
}
</script>

<style scoped lang="scss">

.result-race {
  width: 100%;
  height: 100%;

  .title-wr {
    border-bottom: 1px solid var(--geoff-menu-item-separator);
    display: flex;
    justify-content: space-between;
    gap: 0.75rem;
    align-items: center;
    height: 2.375rem;

    .title {
      font-size: 0.8125rem;
      font-weight: 600;
    }
  }

  .sport-icon {
    width: 1.375rem;
    height: 1.375rem;
    display: flex;
  }

  .result-line {
    display: flex;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    justify-content: space-between;
    gap:0.25rem;

    &:last-child {
      margin-bottom: 0;
    }

    .result-main {
      display: flex;
    }

    .result-odd {
       font-weight: 600;
       white-space: nowrap;
    }

    .racer-image-wr {
      height: 1.3125rem;
      img {
        max-height: 100%;
      }
    }
  }

}

.race-number-comp {
  width: 1.25rem;
  height: 1.25rem;
}

</style>